export default __webpack_public_path__ + "static/media/humanmaskicon.acd4b21a.gif";